var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.noDataYet,"spinner-variant":"primary"}},[_c('b-container',{attrs:{"fluid":""}},[_c('SearchSwitcherWrapper'),_c('b-row',[_c('MapTableWrapper'),_c('RightPanel')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }